export default __webpack_public_path__ + "static/media/Chromebook.84a65048.png";